const Contactanos = () => {
  return (
    <div className="w-full h-[50vh] p-8">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.8334896321344!2d-98.22214112462149!3d19.02705758216746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc1ee45a125a9%3A0xda39a406054f9a3!2sExpert%20Cleaning%20WASH%20%26%20GO!5e0!3m2!1sen!2smx!4v1755885054109!5m2!1sen!2smx"
        className="w-full h-full" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Mapa"
      >
      </iframe>
    </div>
  );
};

export default Contactanos;
